export const SessionCookieNames = {
  authApiV2: 'API_V2_AUTH_COOKIE',
  userName: 'userName',
  lastName: 'lastName',
  businessId: 'businessId',
  businessName: 'businessName',
  userType: 'userType',
};
